<template>
  <div class="child-list-item-mutations">
      <div class="row child">
        <div class="col-3 col-sm-4 col-md-3">
            <child-thumbnail :key="child.child_id" :childReset="getChild(child.child_id).reset" :child="getChild(child.child_id)"></child-thumbnail>
        </div>
        <div class="col-9 col-sm-8 col-md-9">
          <span class="d-none d-sm-block" style="margin-top: 5px"></span>
          <router-link :to="'/children/' + child.child_id + '/planning'">
            <h3>{{ getChild(child.child_id).full_name }}</h3>
            <p v-if="child.type === 'start'">
              Begint op {{ this.$moment(child.date).format('ddd D MMM') }}
            </p>
            <p v-else-if="child.type === 'end'">
              Stopt op {{ this.$moment(child.date).format('ddd D MMM') }}
            </p>
            <p v-else-if="child.type === 'change'">
              Nieuw rooster vanaf {{ this.$moment(child.date).format('ddd D MMM') }}
            </p>
          </router-link>
        </div>
    </div>
  </div>
</template>

<script>
import ChildThumbnail from '@/components/Child-Thumbnail'
export default {
  name: 'child-list-item-mutations',
  props: ['child'],
  components: {
    ChildThumbnail
  }
}
</script>

<style scoped>
  h3, p {
    margin: 0;
  }
  a {
    color: #666;
  }
  .child {
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>
